<div>
  <h3 mat-dialog-title class="bg-white customization-head">Connect Uber Eats</h3>
  @if (confirmConnect) {
    <div class="sub-head pl-4">Authorize Uber Eats to continue</div>
  }
  @if (continueConnect || successConnect || errorConnect || errorAuthorization) {
    <div class="sub-head pl-4">
      Thanks for authorizing uber eats. We are now syncing the data...
    </div>
  }
  <mat-dialog-content class="pt-3 pb-2">
    <div class="row">
      <div class="logo-and-company-name mt-3 mb-3">
        <img class="logo" src="assets/uber_eats.png" />
        <span class="company-name">Uber Eats</span>
        <div class="icon">
          <div class="close-icon">
            <i class="bx bx-x bx-sm"></i>
          </div>
        </div>
        <svg
          class="icon-brand"
          xmlns="http://www.w3.org/2000/svg"
          width="103"
          height="16"
          viewBox="0 0 103 16"
          fill="none"
        >
          <path
            d="M7.00407 14.9105H0.915283V13.6751L1.34189 13.6172C2.03996 13.5207 2.19509 13.2891 2.19509 12.71V3.98503C2.19509 3.40595 2.05935 3.25152 1.41945 3.15501L0.915283 3.0778V1.86171H10.572C10.7465 2.4601 10.8435 4.21667 10.8435 5.29764L9.35038 5.37485L9.23403 4.71855C9.00134 3.52176 8.71048 3.38664 7.72153 3.38664H5.45278V7.7105H9.19525V9.27404H5.45278V12.8451C5.45278 13.3663 5.70487 13.54 6.2866 13.5979L7.00407 13.6751V14.9105Z"
            fill="#121B2B"
          />
          <path
            d="M20.6752 9.94965C20.6752 13.2311 18.7167 15.1614 15.7499 15.1614C12.2207 15.1614 10.7276 13.1539 10.7276 10.0269C10.7276 6.91908 12.8218 4.91158 15.808 4.91158C18.9882 4.91158 20.6752 6.76466 20.6752 9.94965ZM17.5532 10.0076C17.5532 7.15072 16.8358 6.3979 15.7887 6.3979C14.6446 6.3979 13.8496 7.11211 13.8496 9.73731C13.8496 12.9416 14.567 13.6944 15.7499 13.6944C16.8358 13.6944 17.5532 12.8451 17.5532 10.0076Z"
            fill="#121B2B"
          />
          <path
            d="M27.3468 14.9105H21.8203V13.7137L22.2275 13.6365C22.9256 13.5207 22.9644 13.3277 22.9644 12.8837V7.84562C22.9644 7.22793 22.8093 6.99629 21.8785 6.93839V5.83812C22.8287 5.33624 24.5932 4.93088 25.97 4.91158V7.11211C26.2997 5.703 27.0365 4.91158 28.2388 4.91158C28.4521 4.91158 28.6847 4.91158 28.898 4.96948C28.9756 5.16252 28.9756 5.41345 28.9756 5.66439C28.9756 6.16627 28.9174 6.93839 28.8011 7.28584C28.3939 7.22793 28.0642 7.18932 27.754 7.18932C26.9783 7.18932 26.3772 7.40166 25.97 7.76841V12.8451C25.97 13.3084 26.0863 13.54 26.6293 13.6172L27.3468 13.7137V14.9105Z"
            fill="#121B2B"
          />
          <path
            d="M34.4961 14.9105H29.2606V13.7137L29.6484 13.6365C30.3465 13.5207 30.4046 13.3084 30.4046 12.8644V3.86922C30.4046 3.23222 30.3271 2.88477 29.2024 2.82686V1.70729C30.1719 1.18611 32.0529 0.819352 33.4296 0.800049C33.4103 2.28638 33.3909 3.81131 33.3909 5.31694V12.8644C33.3909 13.3856 33.5266 13.5207 34.1083 13.6365L34.4961 13.7137V14.9105ZM40.5074 14.9105C39.9256 15.007 39.053 15.0649 38.5101 15.0649C37.3272 15.0649 36.6486 14.7175 36.1444 14.0419C35.1748 12.7486 34.2247 11.1657 33.6042 10.0269L35.5239 8.05796C36.0474 7.49817 36.3383 7.13142 36.3383 6.86117C36.3383 6.57163 36.0474 6.47512 35.5239 6.41721L35.1361 6.3786V5.20112H40.0032V6.3786L39.7123 6.43651C39.4796 6.45581 39.1888 6.55233 38.9561 6.68745C38.607 6.88048 38.1417 7.24723 37.6957 7.61399L36.1832 8.92659C37.6375 11.3588 38.6652 12.5748 39.1694 13.1346C39.5572 13.54 39.9838 13.6944 40.5074 13.6944V14.9105Z"
            fill="#121B2B"
          />
          <path
            d="M59.0255 15.2C57.3966 15.1421 55.7678 14.7368 54.5268 13.8295C53.6542 14.621 52.4907 15.1614 50.7067 15.1614C47.7205 15.1614 45.6651 13.8102 45.6651 11.1657C45.6651 9.52498 46.9061 8.19308 48.8258 7.6526C48.2247 6.82257 47.9144 5.91533 47.9144 4.95018C47.9144 2.96198 49.4075 1.61077 52.1998 1.61077C53.3439 1.61077 54.7789 1.7845 55.4188 2.01613C55.6708 2.82686 55.7096 4.31318 55.7096 5.33624L54.2747 5.43276L54.1002 4.75715C53.945 4.19737 53.7511 3.88852 53.5572 3.63758C53.2858 3.30943 52.9173 3.13571 52.2774 3.13571C51.4048 3.13571 50.7843 3.65689 50.7843 4.60273C50.7843 5.12391 51.0946 5.85742 51.5599 6.55233C52.5489 8.00005 54.1777 9.75662 55.4382 11.0113C55.6708 10.7411 55.9229 10.2199 56.0587 9.81453C56.1556 9.52498 56.2138 9.23544 56.2138 9.0231C56.2138 8.67565 56.0199 8.46332 55.3606 8.3668L54.8758 8.28959V7.07351H59.3551V8.28959L59.0449 8.3475C58.754 8.40541 58.5407 8.50192 58.405 8.63705C58.2305 8.79147 58.0753 9.06171 57.9396 9.38986C57.4548 10.4901 56.9894 11.3974 56.4853 12.0151C56.97 12.5169 58.0366 13.3856 59.3551 13.9454L59.0255 15.2ZM53.15 12.8451C52.0059 11.8413 50.4159 10.0462 49.7372 8.94589C49.1749 9.38986 48.787 10.0076 48.787 10.8376C48.787 12.3625 49.9893 13.3856 51.4436 13.3856C52.1805 13.3856 52.7622 13.1732 53.15 12.8451Z"
            fill="currentColor"
          />
          <path
            d="M69.5136 14.9105H63.4248V13.6751L63.8514 13.6172C64.5495 13.5207 64.7046 13.2891 64.7046 12.71V3.98503C64.7046 3.40595 64.5689 3.25152 63.929 3.15501L63.4248 3.0778V1.86171H73.0816C73.2561 2.4601 73.353 4.21667 73.353 5.29764L71.8599 5.37485L71.7436 4.71855C71.5109 3.52176 71.22 3.38664 70.2311 3.38664H67.9623V7.7105H71.7048V9.27404H67.9623V12.8451C67.9623 13.3663 68.2144 13.54 68.7961 13.5979L69.5136 13.6751V14.9105Z"
            fill="#121B2B"
          />
          <path
            d="M78.8852 14.9105H73.6497V13.7137L74.0569 13.6365C74.755 13.5207 74.7937 13.3084 74.7937 12.8837V7.90353C74.7937 7.28584 74.6968 7.0349 73.7078 6.97699V5.83812C74.6968 5.31694 76.4614 4.93088 77.8187 4.91158C77.7799 6.32069 77.7799 7.44026 77.7799 8.52123V12.8837C77.7799 13.3856 77.9157 13.54 78.5168 13.6365L78.8852 13.7137V14.9105ZM77.7218 2.4794C77.7218 3.42525 77.0625 4.02364 76.1123 4.02364C75.3367 4.02364 74.5998 3.44455 74.5998 2.4601C74.5998 1.45635 75.3367 0.87726 76.1511 0.87726C76.9849 0.87726 77.7218 1.41774 77.7218 2.4794Z"
            fill="#121B2B"
          />
          <path
            d="M84.981 14.9105H79.823V13.7137L80.2302 13.6365C80.9089 13.5207 80.967 13.3084 80.967 12.8837V7.88423C80.967 7.26654 80.8119 6.99629 79.8811 6.93839V5.83812C80.8507 5.33624 82.6347 4.93088 83.9727 4.91158V6.82257C84.5544 5.60648 85.9118 4.91158 87.2691 4.91158C88.9174 4.91158 89.5573 5.58718 89.79 6.64884C89.8869 7.13142 89.8869 7.76841 89.8869 8.81077V12.9416C89.8869 13.3663 89.9839 13.5207 90.5656 13.6365L91.031 13.7137V14.9105H85.8924V13.7137L86.2802 13.6365C86.765 13.5014 86.8813 13.3856 86.8813 12.9416V8.57914C86.8813 7.84562 86.8231 7.44026 86.6292 7.20863C86.4159 6.91908 86.0281 6.84187 85.5433 6.84187C85.0198 6.84187 84.4186 7.0349 83.9727 7.32445V12.9223C83.9727 13.3663 84.0502 13.5207 84.5932 13.6558L84.981 13.7137V14.9105Z"
            fill="#121B2B"
          />
          <path
            d="M102.823 14.2735C102.106 14.6403 100.108 15.1035 98.6345 15.1035V13.4821C98.1304 14.4086 97.2772 15.1228 95.881 15.1228C93.7868 15.1228 92.0222 13.733 92.0222 10.3743C92.0222 6.51372 94.2716 4.98879 96.7924 4.98879C97.4323 4.98879 98.1692 5.12391 98.6345 5.50997V3.7341C98.6345 3.0778 98.4212 2.86546 97.4711 2.82686V1.72659C98.4406 1.20541 100.302 0.838654 101.679 0.800049C101.66 2.20916 101.64 3.63758 101.64 5.0467V12.2274C101.64 12.8451 101.776 13.1153 102.435 13.1153H102.823V14.2735ZM98.6345 12.7872V6.72605C98.3049 6.59093 97.9171 6.49442 97.5486 6.49442C96.0555 6.49442 95.1829 7.32445 95.1829 10.0076C95.1829 12.7293 96.3076 13.2505 97.3547 13.2505C97.9753 13.2505 98.4212 12.9995 98.6345 12.7872Z"
            fill="#121B2B"
          />
        </svg>
      </div>
      @if (confirmConnect) {
        <div class="pl-3 pr-3">
          <div class="warning-info mt-3 mb-3">
            <div class="icon">
              <div class="warning-icon">
                <i class="bx bx-info-circle text-info"></i>
              </div>
            </div>
            <div class="warning-text">
              You’ll be redirected to Uber Eats to securely log in and grant permission for FnF to
              access your restaurant, menu, and order data.
            </div>
          </div>
        </div>
      }
      @if (connectionLoading) {
        <div class="text-center mt-2 mb-2">
          <div class="mb-4">
            <img class="common-loading" src="assets/menu_loading.gif" alt="common loading" />
          </div>
          <div class="title-description mt-2">
            <p class="spinner-text">
              Uber Eats integration {{ uberEatsConnectStatus | titlecase }}.
            </p>
          </div>
        </div>
      }
      @if (continueConnect) {
        <div class="mt-2 mb-3">
          @for (module of modules; track module; let i = $index) {
            <div
              class="pb-1 text-"
              [ngClass]="
                module.iconDot ? 'text-light' : module.iconCheck ? 'text-success' : 'text-dark'
              "
            >
              @if (module.iconDot) {
                <i class="bx bx-radio-circle pr-3"></i>
              }
              @if (module.iconLoading) {
                <i class="bx bx-loader-circle pr-3 rotate-icon"></i>
              }
              @if (module.iconCheck) {
                <i class="bx bx-check pr-3"></i>
              }
              <span class="module-text">
                {{ module.name }}
                @if (module.iconCheck) {
                  - Synced
                }
                @if (module.iconLoading) {
                  - Syncing...
                }
              </span>
            </div>
          }
          <div class="syncing-text mt-3 text-primary">
            <strong>Important:</strong> Please keep this tab open and do not refresh the page. The
            sync process may take several minutes to complete.
          </div>
        </div>
      }
      @if (successConnect) {
        <div class="text-center mt-2 mb-2">
          <div class="mb-3">
            <!-- <img class="success-connect-img" /> -->
            <img class="connect-img" src="assets/connect-success.png" />
          </div>
          <div class="title-description mt-2">
            <div class="title-sub">All Uber Eats data synced successfully</div>
            <div class="sub-description">
              Your Uber Eats restaurant, menu, and order data are now fully connected with FnF. 
              Everything is up to date, and you’re ready to manage Uber Eats orders seamlessly from
              FnF.
            </div>
          </div>
        </div>
      }
      @if (errorConnect) {
        <div class="text-center mt-2 mb-2">
          <div class="mb-3">
            <img class="error-connect-img" />
          </div>
          <div class="title-description mt-2">
            <div class="title-sub">Uber Eats Sync Failed</div>
            <div class="sub-description">
              The sync did not finish, and your Uber Eats restaurant and order data are not
              connected with FnF.
            </div>
            <div class="sub-description">
              Please restart the setup process from the beginning to try again. If the problem
              continues, contact support for assistance.
            </div>
          </div>
        </div>
      }
      @if (errorAuthorization) {
        <div class="text-center mt-2 mb-2">
          <div class="mb-3">
            <img class="error-connect-img" />
          </div>
          <div class="title-description mt-2">
            <div class="title-sub">Uber Eats Authentication Failed</div>
            <div class="sub-description">
              We were unable to connect your Uber Eats restaurant and order data with FnF. The
              authentication process did not complete successfully, and your data could not be
              synced.
            </div>
          </div>
        </div>
      }
    </div>
    <div class="custom-line-top mt-1"></div>
  </mat-dialog-content>
  @if (connectionLoading) {
    <mat-dialog-actions class="justify-content-end gap-3 pt-1 pb-3 pr-4">
      <button type="button" class="btn btn-neutral ml-3 w-100 common-add-btn" mat-dialog-close>
        Cancel
      </button>
    </mat-dialog-actions>
  } @else if (confirmConnect) {
    <mat-dialog-actions class="justify-content-end gap-3 pt-1 pb-3 pr-4">
      <button
        class="btn btn-white border rounded-3 text-black-50 w-25 common-add-btn bg-white"
        mat-dialog-close
      >
        Cancel
      </button>
      <button
        type="button"
        class="btn btn-dark rounded-3 common-add-btn"
        (click)="connectUberEats()"
      >
        Connect to Uber Eats
      </button>
    </mat-dialog-actions>
  } @else if (successConnect) {
    <mat-dialog-actions class="justify-content-end gap-3 pt-1 pb-3 pr-4">
      <button
        type="button"
        class="btn btn-dark ml-3 w-100 rounded-3 common-add-btn"
        (click)="finishSetup()"
      >
        Finish Setup
      </button>
    </mat-dialog-actions>
  } @else if (errorConnect || errorAuthorization) {
    <mat-dialog-actions class="justify-content-end gap-3 pt-1 pb-3 pr-4">
      <button
        class="btn btn-white border rounded-3 text-black-50 w-25 common-add-btn bg-white"
        mat-dialog-close
      >
        Cancel
      </button>
      <button
        type="button"
        class="btn btn-dark rounded-3 common-add-btn"
        (click)="connectUberEats()"
      >
        Retry Authorization
      </button>
    </mat-dialog-actions>
  }
</div>
